import { Button, EmptyState, Flex, Menu, HStack, Portal } from '@chakra-ui/react'
import { LuMailCheck, LuFileDown, LuFileText, LuFileCode2, LuArchive } from 'react-icons/lu'

type Props = {
  onGoToInvoices: () => void
  onDownload: (type: 'pdf' | 'xml' | 'zip') => void
}

export default function InvoiceSentState({ onGoToInvoices, onDownload }: Props) {
  return (
    <EmptyState.Root>
      <EmptyState.Content>
        <EmptyState.Indicator>
          <LuMailCheck />
        </EmptyState.Indicator>
        <EmptyState.Title>Rechnung abgeschickt</EmptyState.Title>
        <EmptyState.Description>
          Die Rechnung wurde erstellt und an den hinterlegten Rechnungsempfänger versandt. Sie
          können die erstellte Rechnung in Ihrem Dashboard ansehen und verwalten.
        </EmptyState.Description>

        <Flex gap="4" wrap="wrap" justify="center">
          <Button variant="outline" onClick={onGoToInvoices}>
            Zu meinen Rechnungen
          </Button>

          {/* Download menu */}
          <Menu.Root>
            <Menu.Trigger asChild>
              <Button variant="outline">
                <LuFileDown />
                Rechnung herunterladen
              </Button>
            </Menu.Trigger>

            <Portal>
              <Menu.Positioner>
                <Menu.Content>
                  <HStack gap="2">
                    {/* PDF */}
                    <Menu.Item value="pdf" onClick={() => onDownload?.('pdf')}>
                      <LuFileText /> PDF
                    </Menu.Item>

                    {/* XML */}
                    <Menu.Item value="xml" onClick={() => onDownload?.('xml')}>
                      <LuFileCode2 /> XML
                    </Menu.Item>

                    {/* ZIP */}
                    <Menu.Item value="zip" onClick={() => onDownload?.('zip')}>
                      <LuArchive /> ZIP
                    </Menu.Item>
                  </HStack>
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>
        </Flex>
      </EmptyState.Content>
    </EmptyState.Root>
  )
}
